var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3184_43458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6 1L24.4 1C18.1939 1 12.2421 3.46535 7.8537 7.8537C3.46535 12.2421 1 18.1939 1 24.4L1 55.6C1 61.8061 3.46535 67.7579 7.8537 72.1463C12.2421 76.5347 18.1939 79 24.4 79H55.6C61.8061 79 67.7579 76.5347 72.1463 72.1463C76.5347 67.7579 79 61.8061 79 55.6V24.4C79 18.1939 76.5347 12.2421 72.1463 7.8537C67.7579 3.46535 61.8061 1 55.6 1Z",
    fill: "#FDFF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6 1L24.4 1C18.1939 1 12.2421 3.46535 7.8537 7.8537C3.46535 12.2421 1 18.1939 1 24.4L1 55.6C1 61.8061 3.46535 67.7579 7.8537 72.1463C12.2421 76.5347 18.1939 79 24.4 79H55.6C61.8061 79 67.7579 76.5347 72.1463 72.1463C76.5347 67.7579 79 61.8061 79 55.6V24.4C79 18.1939 76.5347 12.2421 72.1463 7.8537C67.7579 3.46535 61.8061 1 55.6 1Z",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6799 59.9883C27.0306 59.9905 27.3782 59.9185 27.7028 59.7765C28.0275 59.6346 28.3227 59.4254 28.5717 59.1609L40.0023 46.8925L51.4329 59.1609C51.6813 59.4269 51.9762 59.638 52.3008 59.7819C52.6254 59.9259 52.9733 60 53.3246 60C53.676 60 54.0239 59.9259 54.3485 59.7819C54.673 59.638 54.968 59.4269 55.2164 59.1609C55.4648 58.8949 55.6619 58.5791 55.7963 58.2315C55.9308 57.8839 56 57.5114 56 57.1352C56 56.759 55.9308 56.3865 55.7963 56.0389C55.6619 55.6913 55.4648 55.3755 55.2164 55.1095L41.894 40.8439C41.6464 40.5765 41.3517 40.3643 41.027 40.2194C40.7023 40.0746 40.354 40 40.0023 40C39.6505 40 39.3023 40.0746 38.9776 40.2194C38.6529 40.3643 38.3582 40.5765 38.1105 40.8439L24.7881 55.1095C24.5384 55.3747 24.3402 55.6903 24.2049 56.038C24.0696 56.3857 24 56.7586 24 57.1352C24 57.5119 24.0696 57.8848 24.2049 58.2325C24.3402 58.5801 24.5384 58.8957 24.7881 59.1609C25.0371 59.4254 25.3324 59.6346 25.657 59.7765C25.9816 59.9185 26.3293 59.9905 26.6799 59.9883Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6799 39.9883C27.0306 39.9905 27.3782 39.9185 27.7028 39.7765C28.0275 39.6346 28.3227 39.4254 28.5717 39.1609L40.0023 26.8925L51.4329 39.1609C51.6813 39.4269 51.9762 39.638 52.3008 39.7819C52.6254 39.9259 52.9733 40 53.3246 40C53.676 40 54.0239 39.9259 54.3485 39.7819C54.673 39.638 54.968 39.4269 55.2164 39.1609C55.4648 38.8949 55.6619 38.5791 55.7963 38.2315C55.9308 37.8839 56 37.5114 56 37.1352C56 36.759 55.9308 36.3865 55.7963 36.0389C55.6619 35.6913 55.4648 35.3755 55.2164 35.1095L41.894 20.8439C41.6464 20.5765 41.3517 20.3643 41.027 20.2194C40.7023 20.0746 40.354 20 40.0023 20C39.6505 20 39.3023 20.0746 38.9776 20.2194C38.6529 20.3643 38.3582 20.5765 38.1105 20.8439L24.7881 35.1095C24.5384 35.3747 24.3402 35.6903 24.2049 36.038C24.0696 36.3857 24 36.7586 24 37.1352C24 37.5119 24.0696 37.8848 24.2049 38.2325C24.3402 38.5801 24.5384 38.8957 24.7881 39.1609C25.0371 39.4254 25.3324 39.6346 25.657 39.7765C25.9816 39.9185 26.3293 39.9905 26.6799 39.9883Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3184_43458",
    x: 0,
    y: 0,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3184_43458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3184_43458",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f0be3e8d5ebd664dc2412e350c6785dc.svg";
export { ForwardRef as ReactComponent };